export const WHATSAPP_DISPLAY = "(71) 9 9732-2934";
export const WHATSAPP_URL = "https://wa.me/5571997322934?text=Ol%C3%A1%2C%20quero%20saber%20mais%20sobre%20o%20Delivery%20Marac%C3%A1s";
export const ADMIN_URL = "https://painel.deliverymaracas.com.br/admin";
export const APP_STORE_URL = "#";
export const PLAY_STORE_URL = "#";
export const MERCHANT_API = "https://api.deliverymaracas.com.br";
